import Datepicker from "react-tailwindcss-datepicker";

const DateRangePicker = (props: any) => {
  const { label, setValue, name, getValues } = props

  const handleValueChange = (newValue: any) => {
    if (newValue?.startDate && newValue.endDate) {
      setValue(name, `${newValue?.startDate},${newValue.endDate}`);
    } else {
      setValue(name, "")
    }
  };

  return (
    <div className="mt-2">
      <label htmlFor="" className="">{label}</label>
      <div className="mt-[12px]">
        <Datepicker
          inputClassName={"focus:outline-none bg-[#EEF5F4] w-full p-2"}
          value={{ startDate: getValues()?.[name]?.split(",")?.[0]??null, endDate: getValues()?.[name]?.split(",")?.[1]??null }}
          primaryColor={"pink"}
          onChange={handleValueChange}
          showShortcuts={true}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
